module.exports = __webpack_public_path__ + "static/media/promo-letnoo-otdyh.3fc55f22.jpg";